// images
import blogImg1 from "../images/blog/white teff.jpg";
import blogImg2 from "../images/blog/red teff.jpg";
import blogImg3 from "../images/blog/brown teff.jpeg";

import blogSingleImg1 from "../images/blog/1.jpg";
import blogSingleImg2 from "../images/blog/2.jpg";
import blogSingleImg3 from "../images/blog/3.jpg";

const blogs = [
    {
        id: '1',
        title: 'ነጭ ጤፍ: የኢትዮጵያ የብርቅ ምግብ ምርጥ ምርት',
        title2: 'ነጭ ጤፍ እንጀራ የጤና ጠቀሜታዎች',
        tag: 'ምግብ እና መጠጥ',
        slug: 'ነጭ-ጤፍ-ጤና-ጠቀሜታ',
        screens: blogImg1,
        description: 'ነጭ ጤፍ የተለያዩ የጤና ጠቀሜታዎች አሉት። ብዙ ፕሮቲን፣ ካልሲየም እና አስፈላጊ አሚኖ አሲድ ይዟል።',
        author: 'የጤፍ ምርመራ ቡድን',
        create_at: 'መስከረም ፫, ፳፻፲፮',
        blogSingleImg: blogSingleImg1,
        comment: '35',
        day: '28',
        month: 'መጋቢት',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'ምግብ እና መጠጥ',
    },
    
    {
        id: '3',
        title: 'ጥቁር ጤፍ: የባህል እና ትውልድ ምግብ',
        title2: 'ቡናማ ጤፍ እና የኢትዮጵያ ባህል',
        tag: 'ባህል እና ትውልድ',
        slug: 'ቡናማ-ጤፍ-ባህል',
        screens: blogImg2,
        description: 'ቡናማ ጤፍ በኢትዮጵያ ባህል ውስጥ ልዩ ቦታ አለው። በተለይም በበዓላት እና ልዩ ክስተቶች ይጠቀማል።',
        author: 'የጤፍ ምርመራ ቡድን',
        create_at: 'መስከረም ፫, ፳፻፲፮',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'መጋቢት',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'ባህል እና ትውልድ',
    },
    {
        id: '3',
        title: ' የኢትዮጵያዉያን ጤፍ',
        title2: ' የኢትዮጵያዉያን ጤፍ',
        tag: 'ባህል እና ትውልድ',
        slug: 'ጥቁር-ጤፍ-ባህል',
        screens: blogImg2,
        description: ' የኢትዮጵያ ጤፍ ።',
        author: 'የጤፍ ምርመራ ቡድን',
        create_at: 'መስከረም ፫, ፳፻፲፮',
        comment: '35',
        day: '28',
        month: 'መጋቢት',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'ባህል እና ትውልድ',
    },
];

export default blogs;